export default __webpack_public_path__ + "static/media/learose3-480w.2e32c88f.webp";